<template>
  <div class="footer">
    <p>Copyright © 2023 天津拂云科技有限公司</p>
    <p>津ICP备2022009798号-2</p>
    <p>
      <a href="https://accessview.tjfytech.com/protocol.html" target="_blank"
        >用户协议</a
      >
      <span>|</span>
      <a href="https://accessview.tjfytech.com/privacy.html" target="_blank"
        >隐私政策</a
      >
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.footer {
  padding: 40px 0;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  a {
    text-decoration: none;
    outline: none;
    color: #999999;
    &:hover {
      color: #3370ff;
    }
  }
  span {
    padding: 0 5px;
  }
}
</style>
